import {useAttendeeBilling} from 'attendee/Billing/Providers/AttendeeBillingProvider'
import {Loader} from 'attendee/theme/Loader'
import {useI18n} from 'i18n/I18nContext'
import moment from 'moment'
import React, {useEffect} from 'react'

export function Payments() {
  const {t} = useI18n()
  const {payments, getPayments, loading} = useAttendeeBilling()

  useEffect(() => {
    getPayments()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (loading) return <Loader />

  return (
    <div className="attendant__wrapper mb-35">
      <table>
        <thead>
          <tr>
            <th>{t('orgInvoiceTx.thNumber')}</th>
            <th>{t('orgInvoiceTx.thDate')}</th>
            <th>{t('orgInvoiceTx.thAmount')}</th>
            <th>{t('orgPaymentTx.thStatus')}</th>
            <th>{t('orgInvoiceTx.thPurchase')}</th>
          </tr>
        </thead>
        <tbody>
          {payments.length === 0 && (
            <tr>
              <td colSpan={5}>{t('orgInvoiceTx.empty')}</td>
            </tr>
          )}
          {payments &&
            payments.map((payment, index) => {
              return (
                <tr key={1}>
                  <td>
                    <div className="attendant__serial">
                      <span> {index + 1} </span>
                    </div>
                  </td>
                  <td>
                    <div className="attendant__date">
                      <span>
                        {moment
                          .unix(payment.created)
                          .format('DD.MM.YYYY HH:mm')}{' '}
                      </span>
                    </div>
                  </td>
                  <td>
                    <div>
                      <span> {(payment.amount / 100).toFixed(2)} €</span>
                    </div>
                  </td>
                  <td>
                    <div className="attendant__status">
                      {payment.status === 'succeeded' && (
                        <span className={'status__tag bg-green'}>
                          <span>{t('orgPaymentTx.paid')}</span>
                        </span>
                      )}
                      {payment.status !== 'succeeded' && (
                        <span className={'status__tag bg-warn'}>
                          <span>{t('orgPaymentTx.failed')}</span>
                        </span>
                      )}
                    </div>
                  </td>
                  <td>
                    <div>
                      <span> {payment.description}</span>
                    </div>
                  </td>
                </tr>
              )
            })}
        </tbody>
      </table>
    </div>
  )
}
